import React from 'react'
import Layout from '../components/layout/Layout'
import { Col, Container, Row } from 'react-bootstrap'
import Quality from '../components/RepeatedComponents/QualitySection/Quality'
import Material from '../components/RepeatedComponents/Material_section/Material'
import IndustriesSlider from '../components/RepeatedComponents/SliderView/IndustriesSlider'
import Founder from '../components/RepeatedComponents/FounderMsg/Founder'
import QualityControl from '../components/RepeatedComponents/QualityControl/QualityControl'
import CustomerSupport from '../components/RepeatedComponents/CustomerSupport/CustomerSupport'
import { Helmet } from 'react-helmet-async'

const About = () => {
  return (
    <Layout>

      {/* Page-level SEO */}
      <Helmet>
        <title>About Us | MSH Metal Craft</title>
        <meta
          name="description"
          content="MSH Metal Craft is a globally trusted manufacturer of precision brass and metal components. Learn about our quality, materials, and founder's vision."
        />
        <meta
          name="keywords"
          content="Brass components, Stainless Steel parts, Metal precision components, MSH Metal Craft, CNC manufacturing"
        />
        {/* Open Graph / Social Tags */}
        <meta property="og:title" content="About Us | MSH Metal Craft" />
        <meta
          property="og:description"
          content="Discover MSH Metal Craft's commitment to high-precision metal components and global quality standards."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.mshmetalcraft.com/about" />
        {/* Replace this with your actual image */}
        <meta property="og:image" content="https://www.mshmetalcraft.com/images/about-og.jpg" />
      </Helmet>

      <section className='about_section'>
        <Container fluid="md">
          <Row>
            <Col lg="12" md="12">
              <div className=''>
                <h1>Precision Engineering Built on Quality</h1>
                <p>Providing from Brass, S.S, Mild Steel, Copper & any special material as per customer requirements <br />Our target is to provide zero defects products  to client which is remarkable in industry.</p>
                {/* <Button className='contact-us-btn custom-btn mt-3'>Contact us</Button> */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className='business_section'>
        <Container fluid="md">
          <Row>
            <Col lg="6" md="12">
              <div className='business_info'>
                <h2>Globally Trusted for Excellence in Metal Precision Components</h2>
                <p>With decades of industry experience and an unwavering commitment to total quality, MSH Metal Craft has earned a strong reputation in the global brass components market. Our precision-engineered products cater to a wide range of sectors, including automotive, electrical, defense, plastic molding, construction, and other industrial applications.</p>
                <p className='mt-3'>From the beginning, our focus has been on continuous improvement—empowering our skilled workforce through ongoing training and investing in state-of-the-art CNC technology to drive innovation and efficiency. At MSH Metal Craft, we strive to be a key player and a pioneer in the manufacturing and global supply of high-precision brass and metal-turned components.</p>
                <div className='founder_name mt-5'>
                  <h5>Mr. Maulik sojitra</h5>
                  <p>Founder, MSH Metal Craft</p>
                </div>
              </div>
            </Col>
            <Col lg="6" md="12" className='mt-4 mt-mg-0'>
              <div className='company_img'></div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className='quality'>
        <Container fluid="md">
          <Quality />
        </Container>
      </section>

      <section className='qualyti_control'>
        <Container fluid="md">
          <QualityControl />
        </Container>
      </section>

      <section className='material_we_use'>
        <Container fluid="md">
          <Material />
        </Container>
      </section>

      <section className='founder_msg'>
        <Container fluid="md">
          <Founder />
        </Container>
      </section>

      <section className='industries'>
        <Container fluid="md">
          <IndustriesSlider />
        </Container>
      </section>

      <section className='customer_support'>
        <Container fluid="md">
          <CustomerSupport />
        </Container>
      </section>

    </Layout>
  )
}

export default About
